import { FC, useContext } from 'react';
import { Box, Typography } from '@mui/material';
import DatePicker from 'react-multi-date-picker';
import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { CampaignContext } from '../../contexts/CampaignContext';
import DateObject from 'react-date-object';

type IReleaseDate = {
	inputClassName?: string;
	datePickerLabel?: string;
	isCreateMode?: boolean;
	showLabel?: boolean;
	className?: string;
	error?: boolean;
	helperText?: string;
};

const ReleaseDate: FC<IReleaseDate> = ({ inputClassName, isCreateMode, showLabel = true, className }) => {
	const { selectedDate, fetchedCampaign, setSelectedDate } = useContext(CampaignContext);
	const { t } = useTranslation();

	const minDate = new DateObject({ calendar: persian }).add(1, 'days');

	const handleDateChange = (date: DateObject | null, _: { validatedValue: string | string[]; input: HTMLElement; isTyping: boolean }): void => {
		if (date) {
			setSelectedDate(dayjs(date.toDate())); // تبدیل DateObject به Dayjs
		} else {
			setSelectedDate(null);
		}
	};

	if (!isCreateMode && !fetchedCampaign?.release_date) {
		return <></>;
	}

	return (
		<Box className={`mt-4 flex items-center gap-x-4 rounded-lg bg-background-paper p-6 ${className}`}>
			{showLabel && <Typography className="me-14 text-xl text-text-primary">{t('week_date_and_day')}</Typography>}
			<div className="flex flex-col gap-y-2">
				<DatePicker inputClass="custom-input" className={inputClassName} minDate={minDate} calendar={persian} locale={persian_fa} onChange={handleDateChange} value={selectedDate ? new DateObject(dayjs(selectedDate).toDate()) : null} calendarPosition="bottom-right" disabled={!isCreateMode} />
			</div>
		</Box>
	);
};

export default ReleaseDate;
